"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dashboard_component_1 = require("./dashboard.component");
var tenant_overview_component_1 = require("./tenant-overview/tenant-overview.component");
var routes = [
    {
        path: "",
        component: dashboard_component_1.DashboardComponent
    },
    {
        path: "tenants",
        component: tenant_overview_component_1.TenantOverviewComponent
    }
];
var FuseDashboardModule = /** @class */ (function () {
    function FuseDashboardModule() {
    }
    return FuseDashboardModule;
}());
exports.FuseDashboardModule = FuseDashboardModule;
